import React from "react";
import ProducerCodeTypeTable from "./ProducerCodeTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const ProducerCodeType = () => {
  const viewPermission = PERMISSIONS.permission_utilities_carrierprogram_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div>
      {/* {userPermissions.includes(viewPermission) && <CarrierProgramTable />} */}
      <ProducerCodeTypeTable />
    </div>
  );
};

export default ProducerCodeType;
